let Core = require('../modules/core/');
let Poster = require('../modules/poster/');
let PlayButton = require('../modules/playButton/');
let Control = require('../modules/recodeControl/');
let Title = require('../modules/title/');
let ErrorBox = require('../modules/error');
let statistics = require('../modules/statistics');
let List = require('../modules/list/');
let Network = require('../modules/network/');
let Events = require('f.core.event');
let Cutdown = require('../modules/cutdown/');
let Ready = require('../modules/ready/');

let mp4Url = '//dyn.v.ifeng.com/cmpp/video_msg_ipad.js';
let ugcMp4Url = '//api.cmpp.v.ifeng.com/index.php/live/video';

let getVideoInfo = function(options) {
    let url = options.from && options.from == 'ugc' ? ugcMp4Url : mp4Url;
    let msg = options.from && options.from == 'ugc' ? options.uid + '@' + options.liveVideoId : options.liveVideoId;

    if (!(options.from && options.from == 'ugc')) {
        let id = options.liveVideoId.split('-')[0];
        return $.ajax({
            url: '//tv.ifeng.com/h6/' + id + '__callback' + id + '_/video.json',
            type: 'get',
            jsonpCallback: 'callback' + id,
            dataType: 'jsonp'
        });
    }
    return $.ajax({
        url: url,
        dataType: 'jsonp',
        data: {
            msg: msg,
            rt: 'js',
            param: 'playermsg'
        }
    });
};

let Video = function(options) {
    this.options = options;
    this.isSpread = true;
    this.init();
    this.currentTime = 0;
};

Video.prototype.init = function() {
    this.initParams();
    this.initLayout();
    this.initCompontent();
    this.initEvent();
};

Video.prototype.initParams = function() {};

Video.prototype.initLayout = function() {
    this.el = document.createElement('div');
    this.el.classList.add('c-video');
};

Video.prototype.initCompontent = function() {
    // var url = this.options.from && this.options.from == 'ugc' ?
    //           ugcMp4Url : mp4Url;
    // var msg = this.options.from && this.options.from == 'ugc' ?
    //           this.options.uid + '@' + this.options.guid : this.options.guid;

    // playermsg = {
    //   "videoid": "0430de49-548b-4d13-9ac9-5fccd0b04248",
    //   "ratio": "4:3",
    //   "largePoster": "//d.ifengimg.com/w400_h300/p0.ifengimg.com/pmop/2016/12/06/e697da70-4c02-4110-8a32-366c71f14ca9.jpg",
    //   "videoplayurl": "//ips.ifeng.com/video19.ifeng.com/video09/2016/12/06/4396652-102-008-0746.mp4",
    //   "categoryId":"0031-0000",
    //   "columnName":""
    // };

    // this.playermsg = $.ajax({
    //   url: url,
    //   dataType: 'jsonp',
    //   data: {
    //     msg: msg,
    //     rt: 'js',
    //     param: 'playermsg'
    //   },
    //   context: this,
    // });

    let self = this;
    let videoOption = this.options.list[0];
    this.playermsg = getVideoInfo(videoOption);

    this.core = new Core({
        src: this.options.src,
        poster: videoOption.poster,
        inline: true,
        autoplay: this.options.autoplay,
        loop: true
    });

    pageVideoList.push(this.core);

    this.poster = new Poster(videoOption.poster);

    // this.core = new Core({
    //   src: this.options.src,
    //   poster: this.options.poster,
    //   inline: true
    // });

    this.playButton = new PlayButton();
    this.playButton.changeState('pause');
    this.control = new Control(this.options);
    this.title = new Title(this.options.title, this.options.channelName, this.options.channelIcon);
    this.error = new ErrorBox(this.options.errorTitle);
    this.cutdown = new Cutdown(this.options.start_time);
    this.list = new List(this.options.list);
    this.network = new Network();

    this.core.renderTo(this.el);

    this.poster.renderTo(this.el);

    this.playButton.renderTo(this.el);
    this.control.renderTo(this.el);
    this.title.renderTo(this.el);
    this.error.renderTo(this.el);
    this.cutdown.renderTo(this.el);
    this.list.renderTo(this.el);
    this.network.renderTo(this.el);
};

Video.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.el);
};

/**
 * 自定义事件列表
 * begin 每个视频开始播放时 一般用来发cv统计
 * ended 视频播放结束时
 * pause 视频暂停
 * play 视频播放
 * switch 视频切换
 * init 初始化视频 主要用于发vv统计
 */
Video.prototype.initEvent = function() {
    let core = this.core;
    let control = this.control;
    let playButton = this.playButton;
    let poster = this.poster;
    let title = this.title;
    let error = this.error;
    let list = this.list;
    let network = this.network;
    let cutdown = this.cutdown;
    let self = this;

    core.on('begin', function() {
        console.log('=======begin');
        self.playermsg.then(function(msg) {
            statistics(msg, 'cv');
        });
        self.control.show();
        self.trigger('begin');
    });

    // 视频内部切换
    core.on('switch', function(oldSrc, newSrc) {
        self.trigger('switch', oldSrc, newSrc);
    });

    core.on('loadedmetadata', function() {
        self.playermsg.then(function(msg) {
            statistics(msg, 'vv');
        });
        self.trigger('init');
    });

    // 视频播放
    core.on('play', function() {
        console.log('-------play====');
        self.trigger('hideCount');
        // let current = Core.current();
        // if (current && core != current) {
        //     current.pause();
        // }
        for (let i = 0; i < pageVideoList.length; i++) {
            const otherCore = pageVideoList[i];
            if (otherCore !== core) {
                otherCore.pause();
            }
        }
        // 由于安卓端兼容性原因，将控层的样式修改放在video的timeupdate事件中
        // playButton.changeState('play');
        // control.changePlayState('play');
        // poster.hide();
        error.hide();
        network.hide();
    });

    // 视频暂停
    core.on('pause', function() {
        playButton.changeState('pause');
        control.changePlayState('pause');
        self.trigger('pause');
        if (self.isSpread) {
            self.trigger('pauseAd');
        }
    });

    // 视频播放完成
    core.on('ended', function() {
        playButton.changeState('replay');
        self.trigger('ended');
    });

    core.on('error', function(e) {
        error.show();
        self.trigger('error', e);
    });

    // 视频播放更新
    core.on('timeupdate', function() {
        let duration = core.getDuration();
        let currentTime = core.getCurrentTime();
        if (currentTime > 0.1) {
            playButton.changeState('play');
            control.changePlayState('play');
            poster.hide();
        }
        control.setTime(currentTime / duration, false);
        control.setTimeVal(Math.floor(duration - currentTime));
        self.trigger('timeupdate', core.getCurrentTime());
        self.currentTime = currentTime;
    });

    title.on('exit', function() {
        self.trigger('exit');
        console.log('exit');
    });

    // 点击播放器前面的控制蒙层
    playButton.on('click', function(e) {
        if (self.isSpread) {
            // 展开
            if (core.getEnded() || core.getPaused()) {
                core.play();
            } else {
                control.toggle();
                return;
            }
        } else {
            // 折叠
            self.trigger('shrinkOpen');
            if (core.getEnded() || core.getPaused()) {
                core.play();
                return;
            } else {
                // core.pause();
                return;
            }
        }

        if (core.getNetworkState() == 3) {
            control.toggle();
        }
    });

    // 控制条时间轴变化
    control.on('time', function(val) {
        let duration = core.getDuration();
        if (duration) {
            core.setCurrentTime(duration * val);
        }
    });

    // 控制条点击播放按钮
    control.on('play', function() {
        if (core.getPaused()) {
            core.play();
        } else {
            core.pause();
            // 暂停添加居中广告
            if (self.isSpread) {
                self.trigger('pauseAd');
            }
        }
    });

    control.on('zoom', function(state) {
        self.trigger('zoom', state);
    });

    // 控制条隐藏的同时，隐藏标题
    control.on('show', function() {
        title.show();
        list.show();
        self.trigger('controlShow');
    });

    // 控制条显示的同时，显示标题
    control.on('hide', function() {
        title.hide();
        list.hide();
        self.trigger('controlHide');
    });

    list.on(
        'switch',
        function(url, index) {
            let videoOption = this.options.list[index];
            core.src(videoOption.mp4);
            core.setPoster(videoOption.poster);
            core.play();
            this.options.playermsg = this.playermsg = getVideoInfo(videoOption);
            this.trigger('switchBarrage', videoOption.liveVideoId);
            this.control.reset();
        }.bind(this)
    );

    network.on('network_retry', function() {
        window.location.reload();
    });

    network.on('network_continue', function() {
        core.play();
        network.hide();
    });

    network.on('network_toggle', function() {
        control.toggle();
    });

    error.on('error_toggle', function() {
        control.toggle();
    });
};

Video.prototype.afterAdPause = function() {
    this.playButton.trigger('click');
};

Video.prototype.play = function() {
    this.core.play();
};

Video.prototype.load = function() {
    this.core.load();
};

Video.prototype.pause = function() {
    this.core.pause();
};

Video.prototype.stop = function() {
    this.core.pause();
    this.control.setTime(0);
};

Video.prototype.next = function(src) {
    this.core.src(src);
    this.control.reset();
    this.playButton.changeState('pause');
};

Video.prototype.getCurrentTime = function() {
    return this.currentTime;
};

Video.prototype.destory = function() {
    this.off();
    this.title.destory();
    this.control.destory();
    this.poster.destory();
    this.playButton.destory();
    this.error.destory();
    core.destory();
};

Video.prototype.hide = function() {
    if (!this.isHide) {
        $(this.el).hide();
        this.isHide = true;
    }
};

Video.prototype.show = function() {
    if (this.isHide) {
        $(this.el).show();
        this.isHide = false;
    }
};

Video.prototype.spread = function() {
    this.isSpread = true;
    this.play();
};

Video.prototype.fold = function() {
    this.isSpread = false;
    // this.pause();
};

Events.mixTo(Video);
module.exports = Video;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/lib/recodeVideo.js